import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { NextArrow, PreviousArrow } from '../arrows';
import './basic.scss';

/**
 * BasicCarousel
 * Usage:
 * <BasicCarousel render={() => loopThroughSlides()} />
 */
class BasicCarousel extends React.Component {
    next() {
        if (this.slider) {
            this.slider.slickNext();
        }
    }

    previous() {
        if (this.slider) {
            this.slider.slickPrev();
        }
    }

    goTo(imageIndex) {
        if (this.slider) {
            const skipAnimation = true;
            this.slider.slickGoTo(imageIndex, skipAnimation);
        }
    }

    render() {
        const {
            render,
            pageType = '',
            settings,
            className,
            arrowClassName,
            children
        } = this.props;
        const defaults = {
            dots: true,
            dotsClass: 'slick-dots slick-thumb mb-2',
            nextArrow: (
                <NextArrow
                    pageType={pageType}
                    arrowClassName={arrowClassName}
                />
            ),
            prevArrow: (
                <PreviousArrow
                    pageType={pageType}
                    arrowClassName={arrowClassName}
                />
            ),
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: true,
            ...settings
        };

        return (
            <div
                data-testid="Basic carousel"
                className={`react-carousel ${className && className}`}>
                <Slider ref={c => (this.slider = c)} {...defaults}>
                    {render ? render() : children}
                </Slider>
            </div>
        );
    }
}

BasicCarousel.propTypes = {
    className: PropTypes.string,
    settings: PropTypes.object,
    render: PropTypes.func,
    pageType: PropTypes.string
};

export default BasicCarousel;
